import React, { useEffect, useState } from "react";
import LoginIcon from "../../../assets/images/generico/LoginIcon";
import { useContext } from "react";
import "./LoginBoxV2.css";
import { PortalContext } from "../../../context/Provider";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import InputV1 from "../../Genericos/InputV1/InputV1";
import { GlobalContext } from "../../../../global/context/Provider";
import axios from "axios";
import { useHistory } from "react-router";

const LoginBoxV2 = ({
  form,
  error,
  onChange,
  onSubmit,
  loginFormValid,
  loading,
}) => {
  const { configState } = useContext(GlobalContext);
  const { registroState, modalState } = useContext(PortalContext);
  const [versionApk, setVersionApk] = useState(false);

  const onKeyPress = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
    if (e.key === "Enter") {
      if (loginFormValid) {
        onSubmit(form);
      }
    }
  };

  useEffect(() => {
    if (configState.config.data) {
      setVersionApk(configState.config.data.version);
    }
  }, [configState.config.data]);

  // const history = useHistory();

  // const [token, setToken] = useState("");
  // const [centro, setCentro] = useState(1);
  // const [loading1, setLoading1] = useState(false);
  // const [error1, setError1] = useState("");

  // const handleClick = async () => {
  //   setLoading1(true);
  //   setError1("");
  //   setToken("");

  //   try {
  //     const resp = await axios.post(
  //       `https://ws-qr-checkin-tokens-test.dim.com.ar/api/token/${centro}/generate`,
  //       {}, // body vacío → Content-Length: 0
  //       {
  //         headers: {
  //           Accept: "*/*",
  //           "Cache-Control": "no-cache",
  //         },
  //         // Si en desarrollo sigues con certificado auto-firmado:
  //         // withCredentials: false,
  //         // httpsAgent: new https.Agent({ rejectUnauthorized: false })
  //       }
  //     );

  //     // Si ya devolvió status 200 en data:
  //     if (resp.data?.status === 200) {
  //       setToken(resp.data.value);
  //       history.push("/?token=" + resp.data.value);
  //       const decoded = decodeToken(resp.data.value);
  //       sessionStorage.setItem("centroID", decoded?.Sede || "9");
  //     } else {
  //       setError1(resp.data.errorMsg || "Respuesta inesperada del servidor");
  //     }
  //   } catch (err) {
  //     // axios lanza aquí si la petición no salió bien
  //     if (err.response) {
  //       setError1(`HTTP ${err.response.status}`);
  //     } else {
  //       setError1(err.message);
  //     }
  //   } finally {
  //     setLoading1(false);
  //   }
  // };
  // const decodeToken = (token) => {
  //   try {
  //     const payload = token.split(".")[1];
  //     const json = atob(payload);
  //     return JSON.parse(json);
  //   } catch (e) {
  //     console.error("Token inválido:", e);
  //     return null;
  //   }
  // };

  return (
    <React.Fragment>
      <div className="container">
        <div className="card">
          <div className="header">
            <div className="title-logo-box">
              <img
                className="ptur-loginBoxImg"
                style={{ width: 260 }}
                src="../../../../assets/images/empresa/IsoLogo.png"
                alt="logo"
              />
            </div>
          </div>
          <div className="bodyCard">
            {/* <h2 className="title rb32m">Hola!</h2> */}
            <div className="form">
              {Array.isArray(form) &&
                form?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <InputV1
                        inputType={item.inputType}
                        name={item.name}
                        headerStr={item.headerStr}
                        headerColor={"c-white"}
                        placeholderText={item.placeholderText}
                        linkStr={item.linkStr}
                        errorStr={modalState.modal.show ? "" : item.errorStr}
                        onChange={onChange}
                        onKeyPress={onKeyPress}
                        value={item.value}
                        className={
                          item.name === "password"
                            ? item.className + " inputNumericShow"
                            : item.name === "nro_documento"
                            ? item.className
                            : item.className + " inputNumeric"
                        }
                        maxLength={item.maxLength}
                        error={error}
                        checkError={modalState.modal.show ? "" : ""}
                        isRequired={item.isRequired}
                        inputMode={item.inputMode}
                        pattern={item.pattern}
                        desactivado={modalState.modal.show}
                      />
                    </React.Fragment>
                  );
                })}
              <button
                className={`${
                  loginFormValid ? "bgc-login pointer " : "bgc-grey65"
                } login-button c-white`}
                disabled={!loginFormValid || loading}
                onClick={onSubmit}
              >
                <LoginIcon />
                Ingresar al portal
              </button>
              <div className="ptur-loginBox-versionPortal">
                <span className="c-grey65 rb12m">{versionApk}</span>
              </div>
            </div>
          </div>
        </div>
        {/* <div style={{ fontFamily: "sans-serif" }}>
          <input
            type="text"
            value={centro}
            onChange={(e) => setCentro(e.target.value)}
            placeholder="Ingrese el token"
          />
          <button
            onClick={handleClick}
            disabled={loading1}
            style={{
              padding: "0.5rem 1rem",
              fontSize: "1rem",
              cursor: loading1 ? "not-allowed" : "pointer",
            }}
          >
            {loading1 ? "Generando…" : "Generar Token"}
          </button>

          {error1 && (
            <p style={{ color: "red", marginTop: "1rem" }}>Error: {error1}</p>
          )}
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default LoginBoxV2;
